import * as Card from 'card';
export class CreditCard extends Card {
/**
 * @param {?} setting
 */
constructor (setting: CardSetting) {
        super(setting);
    }
}
export class Placeholder {
    number =  '•••• •••• •••• ••••';
    name = 'Full Name';
    expiry = '••/••';
    cvc = '•••';
}

function Placeholder_tsickle_Closure_declarations() {
/** @type {?} */
Placeholder.prototype.number;
/** @type {?} */
Placeholder.prototype.name;
/** @type {?} */
Placeholder.prototype.expiry;
/** @type {?} */
Placeholder.prototype.cvc;
}

export class CardSetting {
    form: HTMLElement;
    container: HTMLElement;
    width: number;
    formSelectors: {
        numberInput: string;
        expiryInput: string;
        cvcInput: string;
        nameInput: string;
    };
    formatting = true;
    messages: CardMessages;
    placeholders: Placeholder;
    masks: CardMasks;
    debug = false;
}

function CardSetting_tsickle_Closure_declarations() {
/** @type {?} */
CardSetting.prototype.form;
/** @type {?} */
CardSetting.prototype.container;
/** @type {?} */
CardSetting.prototype.width;
/** @type {?} */
CardSetting.prototype.formSelectors;
/** @type {?} */
CardSetting.prototype.formatting;
/** @type {?} */
CardSetting.prototype.messages;
/** @type {?} */
CardSetting.prototype.placeholders;
/** @type {?} */
CardSetting.prototype.masks;
/** @type {?} */
CardSetting.prototype.debug;
}

export class CardMessages {
    validDate: string;
    monthYear: string;
}

function CardMessages_tsickle_Closure_declarations() {
/** @type {?} */
CardMessages.prototype.validDate;
/** @type {?} */
CardMessages.prototype.monthYear;
}

export class CardMasks {
    cardNumber: string | boolean;
}

function CardMasks_tsickle_Closure_declarations() {
/** @type {?} */
CardMasks.prototype.cardNumber;
}

